import { trackFrontendApisUpltDebugEventLogging } from "@faire/web-api--source/events/frontendApis/actionUnknown/upltDebugEventLogging";
import { useViewport } from "@faire/web/common/hooks/useViewport";
import { TrackDebugEventLoggingCallback } from "@faire/web/common/performance/userPerceivedLoadTiming/types";
import {
  ActionName,
  LoadTimingStatus,
  LoadTimingType,
  LoadTimingDebugInfo,
} from "@faire/web/common/performance/userPerceivedLoadTiming/types";
import { useLocation } from "react-router-dom";

interface IProps {
  name: ActionName;
  userToken: string;
}

export const useTrackDebugEventLoggingCallback = ({
  name,
  userToken,
}: IProps): TrackDebugEventLoggingCallback => {
  const { pathname, search } = useLocation();
  const { isDesktopAndAbove, isMobile } = useViewport();

  return (
    status: LoadTimingStatus,
    loadType: LoadTimingType | undefined,
    debugInfo: LoadTimingDebugInfo
  ) => {
    trackFrontendApisUpltDebugEventLogging(
      name,
      loadType ?? "",
      status,
      pathname,
      search,
      userToken,
      isDesktopAndAbove.toString(),
      isMobile.toString(),
      JSON.stringify(debugInfo)
    );
  };
};
